import React from "react";
import { Grid, Row, Col } from "react-bootstrap";

export default class MetadataTable extends React.Component {
  state = {
    open: false
  };

  get otherMetaClass() {
    if (this.state.open) {
      return "open other-metadata";
    }
    return "other-metadata";
  }

  get tableName() {
    return {
      fontSize: "14px",
      marginBottom: "20px",
      borderBottom: "2px solid #dddfe3",
      marginTop: "15px"
    };
  }

  toggleAccordion() {
    if (this.state.open) {
      this.props.toggleMetadata(null);
    } else {
      this.props.toggleMetadata(this.props.attachment.id);
    }
    this.setState({ open: !this.state.open });
  }

  metadataTableRows() {
    let metadata = this.props.attachment.attributes.other_metadata;
    if (metadata) {
      return Object.keys(metadata).map(key => {
        let value = metadata[key];
        return (
          <tr
            key={key}
            className={`custom-field other-metadata ${this.otherMetaClass}`}
          >
            <td className="col-xs-4">
              <div>
                <strong>{key}</strong>
              </div>
            </td>
            <td className="col-xs-8">
              <div>{value}</div>
            </td>
          </tr>
        );
      });
    }
  }

  metadataAccordion() {
    if (
      this.props.attachment.attributes.other_metadata &&
      this.props.open_meta_key === this.props.attachment.id
    ) {
      return this.metadataTableRows();
    }
  }

  renderDropdownButton() {
    if (this.props.attachment.attributes.other_metadata) {
      if (this.props.open_meta_key === this.props.attachment.id) {
        return (
          <tr
            key="accordion"
            className="accordion-btn metadata s-other-metadata "
            onClick={this.toggleAccordion.bind(this)}
          >
            <td colSpan="2">
              <strong>
                {t('Hide non-indexed metadata')} <i className="fa fa-chevron-up" />
              </strong>
            </td>
          </tr>
        );
      }
      return (
        <tr
          key="accordion"
          className="accordion-btn metadata s-other-metadata "
          onClick={this.toggleAccordion.bind(this)}
        >
          <td colSpan="2">
            <strong>
              {t('Show non-indexed metadata')} <i className="fa fa-chevron-down" />
            </strong>
          </td>
        </tr>
      );
    }
  }

  bestMetadataTableRows() {
    let metadata = this.props.attachment.attributes.best_metadata;
    if (metadata) {
      return Object.keys(metadata).map(key => {
        let value = metadata[key];
        return (
          <tr key={key} className="custom-field">
            <td className="col-xs-4">
              <strong>{key}</strong>
            </td>
            <td className="col-xs-8">
              <p>{value}</p>
            </td>
          </tr>
        );
      });
    }
  }

  render() {
    let { attachment } = this.props;
    return (
      <Grid fluid className="attachment-metadata" id="metadata">
        <Row>
          <Col xs={12}>
            <h5 style={this.table}>
              <a href={attachment.attributes.url} download>
                {attachment.attributes.filename}
              </a>
            </h5>
          </Col>
        </Row>
        <table className="table custom-fields">
          <tbody>
            {this.bestMetadataTableRows()}
            {this.metadataAccordion()}
            {this.renderDropdownButton()}
          </tbody>
        </table>
      </Grid>
    );
  }
}
